"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIBreakString;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function UIBreakString(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hyphenate = _ref.hyphenate,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "hyphenate"]);
  return _react.default.createElement("span", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-break-string', className, {
      'private-break-string--hyphenate': hyphenate,
      'private-break-string--no-hyphenate': !hyphenate
    })
  }), children);
}

UIBreakString.propTypes = {
  children: _propTypes.default.node.isRequired,
  hyphenate: _propTypes.default.bool
};
UIBreakString.defaultProps = {
  hyphenate: true
};
UIBreakString.displayName = 'UIBreakString';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/text/UIBreakString.js
// module id = 175
// module chunks = 209 210 211 212